import { decodedProps } from "@/types/types";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";

export default function useGetToken() {
  const [token, setToken] = useState<string | undefined>();
  const [decode, setDecode] = useState<decodedProps>();

  useEffect(() => {
    setToken(Cookies.get("accessToken"));
    if (token) {
      setDecode(jwtDecode(token));
    }
  }, [token]);

  const actorParams = () => {
    if (decode?.role !== "admin") return null;

    if (decode.komisi !== null) return `komisi=${decode.komisi}`;
    if (decode.fraksi !== null) return `fraksi=${decode.fraksi}`;
    if (decode.dapil !== null) return `dapil=${decode.dapil}`;
    return null;
  };

  return {
    token,
    decode,
    actorParams: actorParams(),
  };
}
